import {Component} from '@angular/core';

@Component({
  selector: 'mc-drawer-left-icon',
  templateUrl: './drawer-left-icon.component.html',
  styleUrls: ['./drawer-left-icon.component.scss'],
})
export class DrawerLeftIconComponent {
  constructor() {}
}
